import React, { useState } from "react";

export default function HardwareSettingsScreen(props) {
  const [selectedTab, setSelectedTab] = useState(0);

  if (!props.show) {
    return <></>;
  }

  return (
    <div>
      <div className="optometry-icon-header">
        <button
          className={`optometry-icon-header-icon ${
            selectedTab === 0 ? "bkg-orange" : ""
          }`}
          disabled={false}
          onClick={() => {
            setSelectedTab(0);
          }}
        >
          <img
            src={
              selectedTab === 0
                ? "/images/optometry-orange.svg"
                : "/images/optometry-blue.svg"
            }
            loading="lazy"
            alt="Icon"
          ></img>
          <span>Impresora de tickets</span>
        </button>
        <button
          className={`optometry-icon-header-icon ${
            selectedTab === 1 ? "bkg-orange" : ""
          }`}
          disabled={false}
          onClick={() => {
            setSelectedTab(1);
          }}
        >
          <img
            src={
              selectedTab === 1
                ? "images/anamnesis-orange.svg"
                : "/images/anamnesis-blue.svg"
            }
            loading="lazy"
            alt="Icon"
          ></img>
          <span>Impresora de etiquetas</span>
        </button>
        <button
          className={`optometry-icon-header-icon ${
            selectedTab === 2 ? "bkg-orange" : ""
          }`}
          disabled={false}
          onClick={() => {
            setSelectedTab(2);
          }}
        >
          <img
            src={
              selectedTab === 2
                ? "/images/rx-orange.svg"
                : "/images/rx-blue.svg"
            }
            loading="lazy"
            alt="Icon"
          ></img>
          <span>Wacom</span>
        </button>
      </div>
      <div className="">Aquí van las pantallas</div>
    </div>
  );
}
